export const messages = {
  en: {
    shopCommunity: {
      search: {
        title: 'Search Conditions',
        shopName: 'Shop Name',
        communityName: 'Community Name',
        state: 'Status'
      },
      list: {
        title: 'Community Shops'
      },
      table: {
        communityId: 'Community ID',
        communityName: 'Community Name',
        shopName: 'Shop Name',
        createTime: 'Entry Time',
        startTime: 'Start Time',
        endTime: 'End Time',
        state: 'Status'
      },
      state: {
        passed: 'Approved',
        rejected: 'Rejected'
      },
      fetchError: 'Failed to fetch shop community data'
    }
  },
  zh: {
    shopCommunity: {
      search: {
        title: '查询条件',
        shopName: '店铺名称',
        communityName: '小区名称',
        state: '状态'
      },
      list: {
        title: '小区商铺'
      },
      table: {
        communityId: '小区编码',
        communityName: '小区名称',
        shopName: '商铺名称',
        createTime: '入驻时间',
        startTime: '开始时间',
        endTime: '结束时间',
        state: '状态'
      },
      state: {
        passed: '审核通过',
        rejected: '审核不通过'
      },
      fetchError: '获取小区商铺数据失败'
    }
  }
}